module.exports = "/virtual-football/img/betting-virtualf-games-holder-bar.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/betting-virtualf-games-holder-bar.png
// module id = 1983
// module chunks = 6